import { render, staticRenderFns } from "./StudentManage.vue?vue&type=template&id=98228776&scoped=true&"
import script from "./StudentManage.vue?vue&type=script&lang=js&"
export * from "./StudentManage.vue?vue&type=script&lang=js&"
import style0 from "./StudentManage.vue?vue&type=style&index=0&id=98228776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98228776",
  null
  
)

export default component.exports